var map = {
	"./match-mode/qSavePlayerTime.graphql": 44939,
	"./match-mode/qSaveUserMatch.graphql": 44488,
	"./match-mode/qUserMatch.graphql": 39275,
	"./match-mode/qUserTeam.graphql": 63366,
	"./modal/qAddExerciseToMatchSave.graphql": 41166,
	"./modal/qAddExerciseToTrainingOpen.graphql": 40690,
	"./modal/qAddExerciseToTrainingReorder.graphql": 86891,
	"./modal/qAddExerciseToTrainingSave.graphql": 72210,
	"./modal/qAddProgramToDateOpen.graphql": 46636,
	"./modal/qAddRatingToTrainingSave.graphql": 69686,
	"./modal/qAddTrainingToDateOpen.graphql": 57059,
	"./modal/qAddTrainingToProgramOpen.graphql": 36520,
	"./modal/qAddTrainingToProgramReorder.graphql": 10820,
	"./modal/qAddTrainingToProgramSave.graphql": 34093,
	"./modal/qCopyExerciseDetails.graphql": 64214,
	"./modal/qCopyExerciseEdit.graphql": 51755,
	"./modal/qCopyExerciseOpen.graphql": 97346,
	"./modal/qCopyExerciseSaveContent.graphql": 41566,
	"./modal/qCopyExerciseSaveEntry.graphql": 54953,
	"./modal/qCopyExerciseSaveFigure.graphql": 68526,
	"./modal/qCopyProgramEdit.graphql": 79264,
	"./modal/qCopyProgramSave.graphql": 12780,
	"./modal/qCopyTrainingEdit.graphql": 35482,
	"./modal/qCopyTrainingSave.graphql": 14745,
	"./modal/qCreateBlueprintOpen.graphql": 74806,
	"./modal/qCreateExerciseConfirm.graphql": 12225,
	"./modal/qCreateExerciseOpen.graphql": 86184,
	"./modal/qCreateExerciseSaveContent.graphql": 77704,
	"./modal/qCreateExerciseSaveEntry.graphql": 53354,
	"./modal/qCreateExerciseSaveFigure.graphql": 95686,
	"./modal/qCreateMatchOpen.graphql": 40585,
	"./modal/qCreateMatchSave.graphql": 32014,
	"./modal/qCreatePlayersSave.graphql": 62540,
	"./modal/qCreateProgramConfirm.graphql": 98255,
	"./modal/qCreateProgramForTrainingAdd.graphql": 48514,
	"./modal/qCreateProgramForTrainingOpen.graphql": 79325,
	"./modal/qCreateProgramForTrainingReorder.graphql": 37507,
	"./modal/qCreateProgramForTrainingSave.graphql": 68992,
	"./modal/qCreateProgramOpen.graphql": 95965,
	"./modal/qCreateProgramSave.graphql": 42458,
	"./modal/qCreateTeamOpen.graphql": 40191,
	"./modal/qCreateTeamPlayers.graphql": 22935,
	"./modal/qCreateTeamSave.graphql": 99152,
	"./modal/qCreateTeamSchedule.graphql": 67112,
	"./modal/qCreateTrainingConfirm.graphql": 32539,
	"./modal/qCreateTrainingForExerciseAdd.graphql": 98492,
	"./modal/qCreateTrainingForExerciseOpen.graphql": 64679,
	"./modal/qCreateTrainingForExerciseReorder.graphql": 57114,
	"./modal/qCreateTrainingForExerciseSave.graphql": 45812,
	"./modal/qCreateTrainingOpen.graphql": 22199,
	"./modal/qCreateTrainingSave.graphql": 97045,
	"./modal/qDeleteExerciseOpen.graphql": 28294,
	"./modal/qDeleteExerciseSave.graphql": 20734,
	"./modal/qDeleteMatchOpen.graphql": 41136,
	"./modal/qDeleteMatchSave.graphql": 74149,
	"./modal/qDeleteProgramOpen.graphql": 53434,
	"./modal/qDeleteProgramSave.graphql": 66662,
	"./modal/qDeleteTeamSave.graphql": 68864,
	"./modal/qDeleteTrainingOpen.graphql": 65297,
	"./modal/qDeleteTrainingSave.graphql": 88650,
	"./modal/qEditExerciseDetails.graphql": 45759,
	"./modal/qEditExerciseOpen.graphql": 39101,
	"./modal/qEditExerciseSaveContent.graphql": 63563,
	"./modal/qEditExerciseSaveEntry.graphql": 34982,
	"./modal/qEditExerciseSaveFigure.graphql": 20142,
	"./modal/qEditMatchSave.graphql": 48338,
	"./modal/qEditPlayersSave.graphql": 7144,
	"./modal/qEditProgramOpen.graphql": 94389,
	"./modal/qEditProgramSave.graphql": 45360,
	"./modal/qEditSubstitutesSave.graphql": 59264,
	"./modal/qEditTeamOpen.graphql": 69481,
	"./modal/qEditTeamSave.graphql": 61025,
	"./modal/qEditTrainingOpen.graphql": 87396,
	"./modal/qEditTrainingSave.graphql": 81609,
	"./modal/qEditTrainingdaysOpen.graphql": 66350,
	"./modal/qEditTrainingdaysSave.graphql": 96097,
	"./modal/qExerciseFieldTypes.graphql": 34099,
	"./modal/qGetCalendarRating.graphql": 92122,
	"./modal/qGetSubstitutes.graphql": 60937,
	"./modal/qGetTrainingRatings.graphql": 2295,
	"./qCalendarSeasons.graphql": 25851,
	"./qCalendarSelection.graphql": 42466,
	"./qExerciseDetail.graphql": 42880,
	"./qExerciseOverview.graphql": 23658,
	"./qExercisePaths.graphql": 2551,
	"./qExercisePurpose.graphql": 85990,
	"./qFallbackDetail.graphql": 43377,
	"./qGlobal.graphql": 84520,
	"./qHomepageDetail.graphql": 72629,
	"./qInfopageDetail.graphql": 80702,
	"./qInfopagePaths.graphql": 19161,
	"./qProgramDetail.graphql": 31247,
	"./qProgramOverview.graphql": 86632,
	"./qProgramPaths.graphql": 24904,
	"./qProgramPrint.graphql": 56567,
	"./qSportCategories.graphql": 31363,
	"./qTeamProfile.graphql": 86804,
	"./qTrainingDetail.graphql": 74609,
	"./qTrainingOverview.graphql": 51189,
	"./qTrainingPaths.graphql": 67508,
	"./qTrainingPrint.graphql": 86210,
	"./qUserExercisePurposeAndActivity.graphql": 71075,
	"./qUserProfile.graphql": 33441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75052;